import { ConfirmationDialog } from '@tabeeb/uikit'

export interface RegenerateSharedLinkDialogProps {
  open: boolean
  onClose: () => void
  onSubmit: () => void
}

const RegenerateSharedLinkDialog: React.FC<RegenerateSharedLinkDialogProps> = ({ open, onClose, onSubmit }) => {
  return (
    <ConfirmationDialog
      onCloseDialog={onClose}
      onSubmit={onSubmit}
      isOpen={open}
      title='Are you sure you want to regenerate the link?'
      dialogMessage='In this case, the old link will be revoked and users will not be able to access the content through the old link'
    />
  )
}

export default RegenerateSharedLinkDialog
